import { Navigate } from 'react-router-dom';
import { useIsSuperAdmin } from '@/lib/permissions';
import { PageSpinner } from '@/components/ui/page-spinner';

interface RequireSuperAdminProps {
  children: React.ReactNode;
}

/**
 * Route guard for super-admin-only areas (e.g. /system-settings).
 *
 * Nav items are already hidden for non-super-admins, but hiding is not
 * enforcement: without this guard a non-super-admin can navigate directly to a
 * system-settings URL and mount its pages (and their queries). RLS is still the
 * ultimate backstop on every underlying table/RPC, but this stops the pages from
 * loading at all. Fails closed while the check is in flight.
 */
export function RequireSuperAdmin({ children }: RequireSuperAdminProps) {
  const { data: isSuperAdmin, isLoading } = useIsSuperAdmin();

  if (isLoading) {
    return <PageSpinner fullScreen />;
  }

  if (!isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
